export default "__VITE_ASSET__v6Gx5Hh$__"